import * as React from 'react';

const SvgXMarkOutlined = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		width="1em"
		height="1em"
		{...props}
	>
		<path
			fill="#60636B"
			fillRule="evenodd"
			d="M17.261 7.55a.75.75 0 1 0-1.06-1.061l-4.349 4.348a.1.1 0 0 1-.141 0L7.36 6.49a.75.75 0 0 0-1.06 1.06l4.349 4.349a.1.1 0 0 1 0 .141L6.3 16.39a.75.75 0 0 0 1.06 1.06l4.35-4.349a.1.1 0 0 1 .141 0l4.349 4.349a.75.75 0 0 0 1.06-1.06l-4.348-4.35a.1.1 0 0 1 0-.141z"
			clipRule="evenodd"
		/>
	</svg>
);
export default SvgXMarkOutlined;
